import React from 'react';
import PaginatedTable from '../../commonComponents/PaginatedTable';
import { Button, Input, Select } from 'antd';
import { useState } from 'react';
import { useUsersAclComponentListing, useUsersDesignationListing } from '../../hooks/useUserAclComponent';
import { useGetAllCompanyCode } from '../../hooks/useSignup';
import DynamicModal from '../../commonComponents/DynamicModal/DynamicModal';
import useLogout from '../../hooks/useLogout';
import EditAclClient from './EditAclClient';
import EditAclComponent from './EditAclComponent';
import { debounce } from 'lodash';

const Users = () => {
    const [pageSize, setPageSize] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);
    const [isModalAcl, setIsModalAcl] = useState(false);
    const [isModalComponentAcl, setIsModalComponentAcl] = useState(false);
    const [aclListing, setAclListing] = useState([]);
    const [aclComponentListing, setAclComponentListing] = useState([]);
    const [targetId, setTargetId] = useState('');
    const [name, setName] = useState('');
    const [clientCode, setClientCode] = useState('');
    const [component, setComponent] = useState('');
    const { data, isFetching, isError, refetch: fetchUserListing } = useUsersAclComponentListing(
        pageNumber,
        pageSize,
        name,
        clientCode,
        component
    );
    const { data: designationList, refetch: fetchDesginationList } = useUsersDesignationListing();
    const { data: companyList } = useGetAllCompanyCode();
    const { logout } = useLogout();

    const columns = [
        {
            title: 'Name',
            key: 'name',
            dataIndex: 'name',
        },
        {
            title: 'Email',
            key: 'email',
            dataIndex: 'email',
        },

        {
            title: 'Designation',
            key: 'Designation',
            dataIndex: 'designation',
        },
        {
            title: 'ACL',
            key: 'Component / ACL',
            render: (_, data) => {
                return (
                    <div>
                        <Button
                            type="default"
                            className="mr-2"
                            onClick={() => {
                                setTargetId(data?._id);
                                setIsModalAcl(true);
                                setAclListing(data?.ACL?.clients ?? []);
                            }}
                        >
                            Client ACL
                        </Button>
                        <Button
                            type="default"
                            onClick={() => {
                                setIsModalComponentAcl(true);
                                setTargetId(data?._id);
                                setAclComponentListing(data?.ACL?.components ?? []);
                            }}
                        >
                            Component ACL
                        </Button>
                    </div>
                );
            },
        },
    ];

    const OnChangePaginator = (pageNum, pageSize) => {
        setPageNumber(pageNum);
        setPageSize(pageSize);
    };

    if (isError) {
        logout();
    }

    const handleUserSearched = debounce(e => {
        const newValue = e.target.value;
        setName(newValue);
        OnChangePaginator(1, pageSize);
    }, 1500);

    return (
        <div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    gap: 8,
                    padding: '10px',
                }}
            >
                <Select
                    showSearch
                    allowClear
                    size="small"
                    placeholder="Filter by client"
                    style={{ width: 180 }}
                    optionFilterProp="label"
                    value={clientCode || undefined}
                    onChange={value => {
                        setClientCode(value || '');
                        OnChangePaginator(1, pageSize);
                    }}
                    options={companyList?.data
                        ?.slice()
                        .sort((a, b) => (a.code || '').localeCompare(b.code || '', undefined, { sensitivity: 'base' }))
                        .map(company => ({
                            value: company.code,
                            label: company.code,
                        }))}
                />
                <Select
                    showSearch
                    allowClear
                    size="small"
                    placeholder="Filter by component"
                    style={{ width: 180 }}
                    optionFilterProp="label"
                    value={component || undefined}
                    onChange={value => {
                        setComponent(value || '');
                        OnChangePaginator(1, pageSize);
                    }}
                    options={designationList?.components?.map(item => ({
                        value: item,
                        label: item,
                    }))}
                />
                <Input
                    size="small"
                    placeholder="Search by name"
                    name="search"
                    style={{ width: 200 }}
                    onChange={e => {
                        handleUserSearched(e);
                    }}
                    allowClear
                />
            </div>
            <PaginatedTable
                dataSource={data?.data}
                columns={columns}
                isFetching={isFetching}
                total={data?.totalCount}
                OnChangePaginator={OnChangePaginator}
                defaultPageSize={20}
                pageNum={pageNumber}
                pageSize={pageSize}
                height={'calc(100vh - 140px)'}
            />

            {isModalAcl && (
                <DynamicModal
                    open={isModalAcl}
                    width={1000}
                    closable={true}
                    close={() => setIsModalAcl(false)}
                    component={
                        <EditAclClient data={aclListing} targetId={targetId} fetchUserListing={fetchUserListing} setIsModalAcl={setIsModalAcl} />
                    }
                />
            )}
            {isModalComponentAcl && (
                <DynamicModal
                    open={isModalComponentAcl}
                    width={1000}
                    closable={true}
                    close={() => setIsModalComponentAcl(false)}
                    component={
                        <EditAclComponent
                            data={designationList}
                            listDesignation={aclComponentListing}
                            targetId={targetId}
                            setIsModalComponentAcl={setIsModalComponentAcl}
                            fetchDesginationList={fetchDesginationList}
                            fetchUserListing={fetchUserListing}
                        />
                    }
                />
            )}
        </div>
    );
};

export default Users;
